/**
 * Erro de permissão (HTTP 403) vindo da API.
 *
 * Existe para que nenhum `catch` volte a tratar "sem acesso" como "falta
 * configurar": foi essa confusão que prendeu assinantes cancelados numa
 * configuração inicial que nunca conclui.
 */
export function isForbiddenError(error: unknown): boolean {
  return (error as { response?: { status?: number } })?.response?.status === 403;
}


/** O pydantic v2 prefixa toda mensagem de validador com isto. */
const PYDANTIC_VALUE_ERROR_PREFIX = /^Value error,\s*/;

/**
 * Mensagem legível a partir do `detail` da API.
 *
 * Em 422 o FastAPI devolve uma *lista* de erros, não uma string: jogada direta
 * no toast, ela chega ao usuário como um JSON de pydantic. Aqui vira a primeira
 * mensagem de verdade, com `fallback` quando não há nenhuma.
 */
export function getApiErrorMessage(detail: unknown, fallback: string): string {
  if (typeof detail === 'string' && detail.trim().length > 0) {
    return detail.replace(PYDANTIC_VALUE_ERROR_PREFIX, '');
  }

  if (Array.isArray(detail) && detail.length > 0) {
    const primeiro = detail[0];
    if (
      primeiro &&
      typeof primeiro === 'object' &&
      'msg' in primeiro &&
      typeof primeiro.msg === 'string'
    ) {
      return primeiro.msg.replace(PYDANTIC_VALUE_ERROR_PREFIX, '');
    }
  }

  return fallback;
}
